<template functional>
    <router-link :id="props.id" class="nav-item" tag="li" :to="props.to" v-if="props.to" exact>
        <a>
            <span class="nav-item-icon" v-if="props.svg">
                <inline-svg :src="props.svg"></inline-svg>
            </span>
            <i v-if="props.icon" :class="props.icon"/>
            <img :width="props.width" v-if="props.img" :src="props.img"/>
            <span class="menu-title">{{ props.label }}</span>
        </a>
    </router-link>
    <li class="nav-item" :id="props.id" v-else-if="listeners.click">
        <a href="#" v-on:click.prevent="listeners.click()">
            <span class="nav-item-icon" v-if="props.svg">
                <inline-svg :src="props.svg"></inline-svg>
            </span>
            <i v-if="props.icon" :class="props.icon"/>
            <img :width="props.width" v-if="props.img" :src="props.img"/>
            <span class="menu-title">{{ props.label }}</span>
        </a>
    </li>
</template>

<script>
export default {
    name: 'MenuItem',
}
</script>
